import { AgFrameworkComponent } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DataGridActionRendererParams } from './data-grid-action-renderer-params';

// export interface CustomGridAction {
//   description: string;
//   class: string;
//   onAction: (entity: any) => void;
// }
// export interface CustomGridActionRendererParams extends ICellRendererParams {
//   actions: CustomGridAction[];
// }

@Component({
  template: `
    <div class="d-flex h-100 align-items-center grid-action-container">
      @for (action of actions; track action) {
        <i
          class="action feather"
          [class]="action.class"
          (click)="action.onAction(params.data)"
          [title]="action.description"
        ></i>
      }
    </div>
    `,
  styles: [
    `
      .grid-action-container .action {
        font-size: 20px;
        cursor: pointer;
        margin-left: 0 !important;
        margin-right: 0.5rem !important;
      }
      .grid-action-container .action.red {
        color: red !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class DataGridActionRenderer
  implements AgFrameworkComponent<DataGridActionRendererParams>
{
  public params!: DataGridActionRendererParams;

  agInit(params: DataGridActionRendererParams): void {
    this.params = params;

    const actual = this.params.api.getColumn('actions')?.getActualWidth();

    const newWidth = this.actions.length * 28 + 10;

    if (!actual || newWidth > actual) {
      this.params.api.applyColumnState({
        state: [
          {
            colId: 'actions',
            width: this.actions.length * 28 + 10,
          },
        ],
      });
    }
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams) {
    // set value into cell again
    this.params = params;
  }

  get actions() {
    return this.params.context.actions.filter((a) =>
      a.visible(this.params.data),
    );
  }
}
